/**
 * A little function to help us with reordering the result
 * @param list
 * @param startIndex
 * @param endIndex
 * @returns
 */
export const reorder = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
